
import { pxToMm } from "@/utils/screen";
import Vue from "vue";
import AppDraggable from "./Draggable.vue";
import { LayoutEditorEventBus } from "./layout-editor-event-bus";
import AppResizable from "./Resizable.vue";

export default Vue.extend({
	data(){
		return {
			storedMaxX: 0,
			storedMaxY: 0,
			ready: false,
			observer: null as null | ResizeObserver
		};
	},
	props: {
		x: Number,
		y: Number,
		disableX: Boolean,
		disableY: Boolean,
		useBottom: Boolean,
		minX: {
			type: Number,
			default: 0
		},
		minY: {
			type: Number,
			default: 0
		},
		maxX: {
			type: Number,
			default: 0
		},
		maxY: {
			type: Number,
			default: 0
		},
		width: Number,
		height: Number,
		minWidth: {
			type: Number,
			default: 10,
		},
		minHeight: {
			type: Number,
			default: 5
		},
		maxHeight: {
			type: Number,
			default: 0
		},
		maxWidth: {
			type: Number,
			default: 0
		}
	},
	computed: {
		computedMaxX():number {
			if (this.maxX != 0) {
				return this.maxX;
			}
			return this.storedMaxX - this.width;
		},
		computedMaxY():number {
			if (this.maxY != 0) {
				return this.maxY;
			}
			return this.storedMaxY - this.height;
		},
		computedMaxWidth():number{
			if (this.maxWidth != 0) {
				return this.maxWidth;
			}
			return this.storedMaxX - this.x;
		},
		computedMaxHeight():number {
			if (this.maxHeight != 0) {
				return this.maxHeight;
			}
			return this.storedMaxY - this.y;
		}
	},
	methods: {
		computeMaxValues(){
			if (!this.observer) return;
			if (!this.$el) return;
			let parentElement = this.$el.parentElement;
			if (!parentElement) return;
			if (!this.ready) {
				this.observer.observe(parentElement);
			}
			let boundingRect = parentElement.getBoundingClientRect();
			this.storedMaxX = pxToMm(boundingRect.width / LayoutEditorEventBus.zoomLevel);
			this.storedMaxY = pxToMm(boundingRect.height / LayoutEditorEventBus.zoomLevel);
			this.ready = true;
		}
	},
	mounted(){
		this.observer = new ResizeObserver(this.computeMaxValues.bind(this));
		this.computeMaxValues();
	},
	destroyed(){
		if (!this.observer) return;
		this.observer.disconnect();
	},
	components: {
		AppDraggable,
		AppResizable
	}
});
